import { Link } from "react-router-dom";
import { footerSocials } from "../data/siteData";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <img
            src="/assets/image/logo white.png"
            alt="Studio logo"
            className="footer-logo"
          />
          <p className="footer-follow">Follow Me On</p>
          <div className="footer-socials">
            {footerSocials.map((social) => (
              <a
                href={social.href}
                key={social.label}
                aria-label={social.label}
                target={social.href.startsWith("http") ? "_blank" : undefined}
                rel={social.href.startsWith("http") ? "noreferrer" : undefined}
              >
                <i className={`fab ${social.icon}`}></i>
              </a>
            ))}
          </div>
        </div>

        <div className="footer-middle">
          <div className="footer-col">
            <h3>Services</h3>
            <ul>
              <li>
                <Link to="/portfolio/graphic">Graphic Design</Link>
              </li>
              <li>
                <Link to="/portfolio/brand">Logo Design</Link>
              </li>
              <li>
                <Link to="/portfolio/ui">UI/UX Design</Link>
              </li>
              <li>
                <Link to="/portfolio/social">Social Media Post</Link>
              </li>
              <li>
                <Link to="/portfolio/ugc">Brand Video</Link>
              </li>
            </ul>
          </div>
          <div className="footer-col">
            <h3>Resources</h3>
            <ul>
              <li>
                <Link to="/portfolio">Mockups</Link>
              </li>
              <li>
                <Link to="/portfolio/thumbnail">Fonts</Link>
              </li>
              <li>
                <Link to="/insights">Courses</Link>
              </li>
              <li>
                <a href="#">Download Resume</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-right">
          <h3>Support</h3>
          <p>
            We are available 24/7 on chat
            <br />
            <Link to="/contact" className="footer-chat-link">
              Click here to start chat
            </Link>
          </p>
          <p>
            Email:
            {" "}
            <a href="mailto:thebiswajitnandistudio@gmail.com">
              thebiswajitnandistudio@gmail.com
            </a>
          </p>
          <p>
            <a href="#">Privacy Policy</a>
          </p>
          <p>
            <Link to="/contact">Send Message</Link>
          </p>
          <form
            className="footer-form"
            onSubmit={(event) => event.preventDefault()}
          >
            <input type="email" placeholder="Your email" aria-label="Your email" />
            <button type="submit">&#10148;</button>
          </form>
        </div>
      </div>
    </footer>
  );
}
